module.exports = __webpack_public_path__ + "static/img/ES-CT.93c64661.svg";